import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { IAppState } from '../../../models/reduxState';
import {
  isSignUpSelector,
  openLinksInNewTabSelector,
  showMoreInsightsExpandedSelector,
} from '../../app/selectors/contactUsSelector';
import { isMultiInsightsEnabledSelector } from '../../app/selectors/selfHelpSelectors';
import { SelfHelpAlchemyInsights } from '../presentationalComponents/SelfHelpAlchemyInsights';
import { setExpandedInsight, toggleShowMoreInsights } from '../reduxUpdater/actions/selfHelpAlchemyActions';
import { getContactUsStyles } from '../styles/contactUsStyles';

const mapStateToProps = (state: IAppState) => {
  return {
    isMultiInsightsEnabled: isMultiInsightsEnabledSelector(state),
    insightFeedbackSubmited: state.ContactState.SelfHelpAlchemyState.insightFeedbackSubmited,
    isActionButtonEnabled: state.ContactState.SelfHelpAlchemyState.isInsightActionButtonEnabled,
    openLinksInNewTab: openLinksInNewTabSelector(state),
    sourceApp: state.GlobalState.sourceApp,
    showMoreInsightsExpanded: showMoreInsightsExpandedSelector(state),
    isSignUp: isSignUpSelector(state),
  };
};

const mapDispatchToProps = {
  setExpandedInsight,
  toggleShowMoreInsights,
};

export const SelfHelpAlchemyInsightsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(SelfHelpAlchemyInsights, getContactUsStyles));
